import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions/client/errors/RequiredPayloadFieldIsNotProvided';
import {
  BackResponse,
  BackResponseFailure,
  FileId,
  TechnicalIntervention,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/technicalIntervention`;

export interface GetTechnicalInterventionQueryPayload {
  fileId: FileId;
}

export const getTechnicalInterventionRequest = ({
  fileId,
}: GetTechnicalInterventionQueryPayload): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { fileId }),
  config: { method: SUPPORTED_METHODS.GET },
});

async function getTechnicalInterventionQuery({
  fileId,
}: GetTechnicalInterventionQueryPayload): Promise<
  BackResponse<TechnicalIntervention> | BackResponseFailure
> {
  const functionName = 'getTechnicalInterventionQuery';

  if (!fileId) {
    throw new RequiredPayloadFieldIsNotProvided('fileId', functionName);
  }

  try {
    return await executeQuery<BackResponse<TechnicalIntervention>>(
      getTechnicalInterventionRequest({ fileId }),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getTechnicalInterventionQuery;
